// extracted by mini-css-extract-plugin
module.exports = {"shopByBrandContainer":"brands-list_shopByBrandContainer__057ht"};